module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-row', {
    staticStyle: {
      "padding-bottom": "0.432em"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-store-alt"
  }), _vm._v(" " + _vm._s(_vm.pluralise('Tenancy', _vm.tenancy.length)))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "right"
    }
  }, [(_vm.isManager('property|finance') && !_vm.readOnly) ? _c('tenancy-action', {
    attrs: {
      "adding": true,
      "site-data": _vm.rowData
    },
    on: {
      "update": _vm.saved
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.tenancy.length === 0) ? _c('div', [(_vm.loading) ? _c('div', [_c('center', [_c('span', {
    staticClass: "fa fa-spinner fa-spin"
  })])], 1) : _c('div', [_c('center', [_c('h3', [_vm._v("No tenancy information found ")])])], 1)]) : _c('div', [(_vm.tenancy.length === 1) ? _c('div', [_c('tenancy', {
    attrs: {
      "row-data": _vm.rowData,
      "tenancy-data": _vm.tenancy[0],
      "index": 0,
      "show-agreement": _vm.showAgreement,
      "editable": _vm.editable,
      "read-only": _vm.readOnly
    },
    on: {
      "update": _vm.saved,
      "deleted": _vm.deleted
    }
  })], 1) : _c('div', [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": 'Site has ' + _vm.plural('landowner', _vm.tenancy.length, true),
      "closable": false,
      "show-icon": ""
    }
  }), _vm._v(" "), _vm._l((_vm.tenancy), function(t, index) {
    return _c('el-collapse', {
      key: index,
      attrs: {
        "accordion": ""
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    }, [_c('el-collapse-item', {
      attrs: {
        "name": index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      staticClass: "text-primary"
    }, [_vm._v(_vm._s((index + 1) + ')') + " "), _c('b', [_vm._v(_vm._s(t.owner && t.owner.name ? t.owner.name : 'Not Found'))])])]), _vm._v(" "), _c('tenancy', {
      attrs: {
        "row-data": _vm.rowData,
        "tenancy-data": t,
        "index": index,
        "show-agreement": _vm.showAgreement,
        "editable": _vm.editable,
        "read-only": _vm.readOnly
      },
      on: {
        "update": _vm.saved,
        "deleted": _vm.deleted
      }
    })], 2)], 1)
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05748dbd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SiteTenancy.vue
// module id = 1397
// module chunks = 0